import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Page from '@zg-rentals/multibrand-ui/lib/Page';
import HeaderNav from '@zg-rentals/multibrand-ui/lib/HeaderNav';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import { Footer } from '@zg-rentals/zrs-comet';

import sharedConfig from '../../../sharedConfig';
import pathsManifest from '../../../pathsManifest';
import queryUtil from '../../../utils/queryUtils';

const HELPER_LINK_PARAM = 'ticket_form_id=360000016927';

const propTypes = {
  email: PropTypes.string,
  loggedIn: PropTypes.bool,
  query: PropTypes.object,
  brand: PropTypes.oneOf(['zillow', 'hotpads', 'trulia']),
  children: PropTypes.node.isRequired,
  isInWebView: PropTypes.bool,
};

class PageTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.goToLogOutPage = this.goToLogOutPage.bind(this);
    this.goToSignInPage = this.goToSignInPage.bind(this);
    this.handleFooterClick = this.handleFooterClick.bind(this);
  }

  goToSignInPage() {
    if (typeof window !== 'undefined') {
      const { pathname } = window.location,
        { brand } = this.props;

      window.location = pathsManifest.signInPage[brand](pathname);
    }
  }

  goToLogOutPage() {
    const { brand } = this.props;
    window.location = pathsManifest.logOutPage[brand];
  }

  handleFooterClick(e) {}

  render() {
    // Updated Zillow footer 4/19/2022 for compliance update
    // and removed HP and T brand footers by passing hideFooter prop
    // into MUI component as those footers are outdated and MUI is deprecated.
    const { brand, email, loggedIn, query, isInWebView } = this.props;
    const isZillowBrand = brand === 'zillow';
    let hideHeaderAndFooter = false;
    if (query.hostApp) {
      hideHeaderAndFooter = query.hostApp === 'ios' || query.hostApp === 'android';
    }

    return (
      <>
        <Page limitedWidth helpUrlQuery={HELPER_LINK_PARAM} hideFooter>
          {hideHeaderAndFooter || isInWebView ? (
            <div />
          ) : (
            <HeaderNav isFluid={!isZillowBrand}>
              <HeaderNav.RightSection>
                <HeaderNav.Links>
                  <Link type="secondary" href="/">
                    {`Go to ${sharedConfig.brandTitles[brand]}`}
                  </Link>
                  {email && loggedIn ? (
                    <Link type="secondary" onClick={this.goToLogOutPage}>
                      Sign out
                    </Link>
                  ) : (
                    <Link type="secondary" onClick={this.goToSignInPage}>
                      Sign in
                    </Link>
                  )}
                </HeaderNav.Links>
              </HeaderNav.RightSection>
            </HeaderNav>
          )}
          {this.props.children}
          {isZillowBrand && !hideHeaderAndFooter && !isInWebView && (
            <div className="full-width">
              <Footer />
            </div>
          )}
        </Page>
      </>
    );
  }
}

PageTemplate.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    brand: state.app.brand,
    loggedIn: state.user.loggedIn,
    email: state.user.email,
    router: state.router,
    query: queryUtil.parse(state.router.location.search),
    isInWebView: state.app.isInWebView,
  };
}

export default withRouter(connect(mapStateToProps)(PageTemplate));
